// assets
import { PictureOutlined } from '@ant-design/icons';

// icons
const icons = {
  PictureOutlined
};

// ==============================|| MENU ITEMS - UTILITY ||============================== //

const grocery = {
  id: 'group-grocery',
  title: 'UTILITY',
  type: 'group',
  children: [
    {
      id: 'banners',
      title: 'Banners',
      type: 'item',
      url: '/banners',
      icon: icons.PictureOutlined,
      breadcrumbs: false
    },

  ]
};

export default grocery;




